import React, { PropsWithChildren, useState } from 'react';
import { useCustomerInformationSystemService } from '../../sdk/CustomerInformationSystemClient';
import { useParams } from 'react-router-dom';
import { useGlobalContext } from '../../GlobalContextProvider';

const CustomerContext = React.createContext({
  customerId: undefined,
  error: undefined,
  setError: undefined,
  customerInformationService: undefined,
});

function CustomerContextProvider({ children }: PropsWithChildren) {
  const { customerId } = useParams();
  const [error, setError] = useState(undefined as any);
  const { tenantId } = useGlobalContext();
  const customerInformationService = useCustomerInformationSystemService(tenantId);

  return (
    <CustomerContext.Provider value={{ customerId, error, setError, customerInformationService }}>
      {children}
    </CustomerContext.Provider>
  );
}

export { CustomerContextProvider, CustomerContext };
